export class DownloadedDocument {
  constructor(public file?: ArrayBuffer,
              public filename?: string) { }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/models/downloaded-document.ts